import { AxiosError } from 'axios';
import { Issue } from 'interface/issueInterface';
import { baseService } from 'services';
import { IErrorResponse, ISuccessResponse } from 'interface/apiInterface';
import { commonError, searchIssueEP } from 'services/constants';
import { IssueSearch } from 'interface/issueInterface';

class IssueMockService {
  commonResponse = async <T = null>(
    data: T | null = null,
  ): Promise<ISuccessResponse<T> | IErrorResponse<AxiosError>> => {
    try {
      return await new Promise<ISuccessResponse>(resolve => {
        setTimeout(() => {
          resolve({
            data: data ?? null,
            status: 200,
            message: 'success',
          });
        }, 1000);
      });
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };

  searchIssues = async () => {
    return this.commonResponse();
  };
}

class IssueService {
  searchIssues = async (
    searchParams: IssueSearch,
  ): Promise<ISuccessResponse<Issue[]> | IErrorResponse<AxiosError>> => {
    try {
      return await baseService.post(searchIssueEP, searchParams);
    } catch (error) {
      return commonError(error as AxiosError, true);
    }
  };
}

const issueService: IssueService | IssueMockService =
  process.env.REACT_APP_MOCK_API === 'true'
    ? new IssueMockService()
    : new IssueService();

export default issueService;
